define('viewmodels/questions/textMatching/textMatchingTarget',[],function() {
    
    return function(value) {
        this.value = value;
    }

});
